import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "app-toolbar py-3 py-lg-6" }
const _hoisted_2 = { class: "app-container d-flex flex-stack" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "page-title d-flex flex-column justify-content-center flex-wrap me-3" }, null, -1)
const _hoisted_4 = { class: "d-flex gap-4" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "app-content flex-column-fluid" }
const _hoisted_10 = { class: "app-container" }
const _hoisted_11 = { class: "card mb-5 mb-xl-10" }
const _hoisted_12 = { class: "card-body pt-9 pb-0" }
const _hoisted_13 = { class: "d-flex flex-wrap flex-sm-nowrap mb-6" }
const _hoisted_14 = { class: "flex-grow-1" }
const _hoisted_15 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = { class: "d-flex align-items-center mb-2" }
const _hoisted_18 = { class: "text-gray-900 fs-2 fw-bold me-1" }
const _hoisted_19 = { class: "d-flex flex-wrap gap-7 fw-semibold fs-6 mb-4 pe-2 mt-2" }
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "svg-icon svg-icon-2" }
const _hoisted_22 = { class: "text-gray-400 ms-1" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "svg-icon svg-icon-2" }
const _hoisted_25 = { class: "text-gray-400 ms-1" }
const _hoisted_26 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_27 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_28 = { class: "d-flex flex-wrap" }
const _hoisted_29 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-2 fw-bold counted" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-400" }, " quantityItems ")
], -1)
const _hoisted_32 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-2 fw-bold counted" })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold fs-6 text-gray-400" }, " total ")
], -1)
const _hoisted_35 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            disabled: _ctx.loading,
            class: "btn btn-secondary align-self-center text-gray-600",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.backToList")), 1)
          ], 8, _hoisted_5),
          (_ctx.baseData.status === _ctx.entityStatus.Deactivated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                disabled: _ctx.loading,
                class: "btn btn-primary align-self-center",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.activateThisEntity && _ctx.activateThisEntity(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("kyc.actions.activate")), 1)
              ], 8, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.baseData.status === _ctx.entityStatus.Activated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                disabled: _ctx.loading,
                class: "btn btn-primary align-self-center",
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deactivateThisEntity && _ctx.deactivateThisEntity(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("kyc.actions.deactivate")), 1)
              ], 8, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.baseData.company_name || "--"), 1),
                      (_ctx.baseData.status)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass([_ctx.getStatus(_ctx.baseData.status).value.color, "badge ms-8"])
                          }, _toDisplayString(_ctx.baseData.status_text), 3))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("span", _hoisted_21, [
                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/id.svg" })
                        ]),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.baseData.id || "--"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, [
                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/maps/map007.svg" })
                        ]),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.getLocation == " " ? "--" : _ctx.getLocation), 1)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      (0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createVNode(_component_el_popover, {
                              placement: "top",
                              width: "auto",
                              trigger: "hover",
                              "popper-class": "price-popover"
                            }, {
                              reference: _withCtx(() => [
                                _hoisted_31
                              ]),
                              default: _withCtx(() => [
                                _hoisted_30
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createVNode(_component_el_popover, {
                              placement: "top",
                              width: "auto",
                              trigger: "hover",
                              "popper-class": "price-popover"
                            }, {
                              reference: _withCtx(() => [
                                _hoisted_34
                              ]),
                              default: _withCtx(() => [
                                _hoisted_33
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("ul", _hoisted_35, [
              _createElementVNode("li", _hoisted_36, [
                _createVNode(_component_router_link, {
                  to: _ctx.goPath + '/' + _ctx.$route.params.id + '/information',
                  "active-class": "active",
                  class: "nav-link text-active-primary me-6",
                  replace: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("kyc.navigation.information")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("li", _hoisted_37, [
                _createVNode(_component_router_link, {
                  to: 
                  _ctx.goPath + '/' + _ctx.$route.params.id + '/historical-information'
                ,
                  "active-class": "active",
                  class: "nav-link text-active-primary me-6",
                  replace: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("kyc.navigation.historicalInformation")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        ]),
        _createVNode(_component_router_view, {
          loading: _ctx.loading,
          baseData: _ctx.baseData,
          onGetFormData: _ctx.getFormInfo
        }, null, 8, ["loading", "baseData", "onGetFormData"])
      ])
    ])
  ], 64))
}